import { MessageReadStatus } from 'components/molecules';
import styled from 'styled-components';

export const StyledMessageReadStatus = styled(MessageReadStatus)`
    margin-top: 0;
    margin-left: 0;
    justify-content: center;
`;
